import React from 'react';
import { withRouter } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import ReactHelmet from 'react-helmet';

import ContentLayout from 'component/page/content';
import {ModalFeedback} from 'component/reuse/modal';
import {BuilderJS, PlayerJS, TriggerJS} from 'component/reuse/js_code';
import Track from 'utils/tracker';


class Page extends React.Component {

  state = {
    show_demo_control: false,
  }

  showDivShowDemoControlButton (e){
    e.preventDefault();

    Track.event("instructions_showDivShowDemoControlButton");

    const state = this.state;
    state.show_demo_control = true;
    this.setState(state);

  }

  render (){

    return (
      <ContentLayout id="list-site-page">

        <div className="container">

          <div className="container my-4">
            <div className="">
              <h2 className="my-4">Summary:</h2>
              <p className="">There are 3 steps to adding DivShow on your pages:</p>
                <ol>
                  <li>Create an <Link to="/instructions#tut-create-api">API key</Link> for your site</li>
                  <li>Use the Divshow Builder script to <Link to="/instructions#tut-record">record a show</Link></li>
                  <li>Replace builder with DivShow player script to <Link to="/instructions#tut-play">play the show</Link></li>
                </ol>
            </div>
          </div>

          <hr className="my-3" />

          <div id="tut-create-api" className="container my-4">
            <h3>1) API key:</h3>
            <div className="container my-2">
              <p className=""><Link to="/sites">Tell us about your site </Link> to generate a builder API key. You can create as many keys as you like. We recommend one API key per subdomain (eg: www, blog, news etc ...)</p>
              <div className="text-center box-shadow btn-rounded m-2"><img src="/static/images/demo/ins_01_cut.gif" alt="DivShow create site" className="btn-rounded"/></div>
            </div>
          </div>

          <hr className="my-3" />

          <div id="tut-record" className="container my-4">
            
            <h3>2) Record a show:</h3>

            <div className="container">

              <p className="">Add the builder javascript (with your API key) on your page to record a show.</p>
              <BuilderJS />

              <p className="">This will add a control button for divshow builder to your page.</p>

              {this.state.show_demo_control? (
                <div className="">
                  <ReactHelmet>
                    <script src="https://divshow.bytebeacon.com/static/sdk/0.0.14/divshow_builder.min.js?api_key=divshow_demo"></script>
                    {/* <script src="http://localhost:3000/static/sdk/0.0.14/divshow_builder.js?api_key=divshow_demo"></script> */}
                  </ReactHelmet>
                  <div className="alert alert-info">
                    DivShow's control button is now visible on the bottom right corner of this screen. 
                    You can play record and replay the show, but you cannot uplaod from this control button! 
                    <br/><br/>
                    You will have to use your own API script to upload and save your custom shows.
                  </div>
                </div>
              ):(
                <div className="">
                  <a href="/instructions" className="btn btn-quaternary my-3 text-white" onClick={this.showDivShowDemoControlButton.bind(this)}>
                    <i className="fa fa-video mr-2"></i>
                    Click here to load the DEMO Divshow builder control button!
                  </a>
                </div>
              )}

              <hr className="my-5"/>

              <div className="">
                <h5>2.1) Control button</h5>
                <div className="row my-2">
                  <div className="col-md-8">
                    <p className="" style={{height: '100%', display: 'grid', alignItems: 'center'}}>
                      A control button shows up near the bottom right corner of the screen. Your browser can ask you for audio permission at this point. Please grant the access for your to be able to record your audio for the show.
                    </p>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center box-shadow btn-rounded"><img src="/static/images/demo/1.png" alt="DivShow Control button" className="btn-rounded"/></div>
                    <p className="text-center text-muted my-3">The builder control button</p>
                  </div>
                </div>
              </div>

              <hr className="my-5"/>

              <div className="">
                <h5>2.2) Start recording</h5>
                <div className='row my-2'>
                  <div className='col-md-8'>
                    <p className="" style={{height: '100%', display: 'grid', alignItems: 'center'}}>
                      Hover over the control button for control options to slide out. Click on the record button to start recording the mouse movement and audio.
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <div className="text-center box-shadow btn-rounded"><img src="/static/images/demo/2.png" alt="Control for starting recording" className="btn-rounded"/></div>
                    <p className="text-center text-muted my-3">Record a show</p>
                  </div>
                </div>
              </div>

              <hr className="my-5"/>

              <div className="">
                <h5>2.3) Stop recording</h5>
                <div className='row my-2'>
                  <div className='col-md-8'>
                    <p className="" style={{height: '100%', display: 'grid', alignItems: 'center'}}>
                      The control button will display a countdown of seconds left before you hit your show time limit. Hovering over the control button will reveal the button to stop your recording.
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <div className="text-center box-shadow btn-rounded"><img src="/static/images/demo/3.png" alt="Control for stopping recording" className="btn-rounded"/></div>
                    <p className="text-center text-muted my-3">Stop recording</p>
                  </div>
                </div>
                </div>
              </div>

              <hr className="my-5"/>

              <div className="">
                <h5>2.4) Replay and Upload</h5>
               <div className='row my-2'>
                 <div className='col-md-8'>
                   <p className="" style={{height: '100%', display: 'grid', alignItems: 'center'}}>
                    Once recording is stopped the control button displays options to replay the show you just recorded, and saving the show for you to import on the recorded page.
                   </p>
                 </div>
                 <div className='col-md-4'>
                   <div className="text-center box-shadow btn-rounded"><img src="/static/images/demo/4.png" alt="Control for replay and show upload" className="btn-rounded"/></div>
                   <p className="text-center text-muted my-3">Playback and show upload</p>
                  </div>
               </div>
              </div>

            </div>

          <hr className="my-3" />

          <div id="tut-play" className="container my-4">
            <h3>3) Play the show:</h3>

            <div className="">
              <p className="mt-5">To play the show just add the following javascript on your page</p>
              <PlayerJS />
              <p className="">and call the <span className="highlight-info-4 text-info btn-rounded ">window.Divshow.Play("INSERT_SHOW_ID_HERE")</span> method from the element that should trigger the show.</p>

              <p className="mt-5">Example button click:</p>
              <TriggerJS />
              <p className="">If you wish to check if the show if properly loaded on a page before you show the trigger button, you can do so by repeatedly calling <span className="highlight-info-2 text-info btn-rounded ">window.Divshow.IsLoaded()</span> method, until it returns <span className="highlight-info-2 text-info btn-rounded ">true</span>.</p>
            </div>

          </div>

          <div className="fa-pull-right">
            <ModalFeedback modalLinkText={"Feedback on Instructions"} modalID={"instruction_feedback"} modalTitle={"Instructions"} />
          </div>

        </div>

      </ContentLayout>
    )
  }
}

export default withRouter(Page);
